/**
 * Where AuthForm.loginWithCredentials sends the user after a successful
 * login (it reads and clears this key).
 *
 * Save it ONLY from an explicit "log in to continue" action (review
 * finding, 2026-10-06). The offer pages used to save it from their
 * onAuthStateChanged listener whenever nobody was signed in, which also
 * fired on LOGOUT while on the page and on visits where the user never
 * logged in, so a later, unrelated login landed on an old offer page.
 *
 * Path + query only, same origin: the offer pages carry their target in
 * the query string (?targetPedalId=...), which is what email links need.
 */
export const LOGIN_RETURN_KEY = 'returnAfterLogin';

export function rememberLoginReturn(loc = window.location) {
  try {
    sessionStorage.setItem(LOGIN_RETURN_KEY, `${loc.pathname}${loc.search}`);
  } catch (e) {
    // Storage blocked (private mode): login still works, it just lands on
    // the dashboard as it always did.
  }
}
